import * as React from "react";
import type { SVGProps } from "react";
const SvgBedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#bed-icon_svg__a)">
      <path
        fill="#333"
        d="M2 2C1.34 2 .8 2.54.8 3.2v5.525c.519-.45 1.175-.814 2-1.1V6c0-1.064 1.817-1.2 3.4-1.2s3.4.136 3.4 1.2v.8c.134-.002.263 0 .4 0s.266-.002.4 0V6c0-1.064 1.817-1.2 3.4-1.2s3.4.136 3.4 1.2v1.612c.823.285 1.477.657 2 1.113V3.2c0-.66-.54-1.2-1.2-1.2zm8 5.6C2.363 7.6-.006 9.012 0 12.8h20c.006-3.812-2.363-5.2-10-5.2m-10 6V19h2.8v-2.6c0-.575.225-.8.8-.8h12.8c.575 0 .8.225.8.8V19H20v-5.4z"
      />
    </g>
    <defs>
      <clipPath id="bed-icon_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBedIcon;
